import { render, staticRenderFns } from "./LazyLoadingPlaceholder.vue?vue&type=template&id=2b24de92&scoped=true"
import script from "./LazyLoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LazyLoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LazyLoadingPlaceholder.vue?vue&type=style&index=0&id=2b24de92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24de92",
  null
  
)

export default component.exports